// src/app/services/extension.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { NicsECheckExtensionResponse } from '../models/nics-extension-message';

@Injectable({ providedIn: 'root' })
export class ExtensionService {
  private extensionInstalled = new BehaviorSubject<boolean>(false);
  extensionInstalled$ = this.extensionInstalled.asObservable();

  /** Emits every well-formed envelope the extension posts back to the page */
  private _extensionMessage$ = new Subject<NicsECheckExtensionResponse>();
  extensionMessage$ = this._extensionMessage$.asObservable();

  /** Emits when the content script's extension context becomes invalidated (extension was reloaded) */
  private _extensionNeedsReload$ = new Subject<void>();
  extensionNeedsReload$ = this._extensionNeedsReload$.asObservable();

  constructor() {
    window.addEventListener('message', this.handleMessage.bind(this), false);
  }

  private handleMessage(event: MessageEvent) {
    if (event.source !== window) { return; }
    const data = event.data;

    // Extension presence ping response
    if (data?.nicsECheck?.extension?.installed) {
      this.extensionInstalled.next(true);
      return;
    }

    // Stale content script notification
    if (data?.extensionContextInvalidated) {
      console.warn('[ExtensionService] Extension context invalidated — extension was reloaded');
      this._extensionNeedsReload$.next();
      return;
    }

    // Extension response envelope
    if (data?.extensionType === 'NicsECheck.Autofill' && data?.messageType) {
      console.log('[ExtensionService] Extension response received:', data.messageType, data);
      this._extensionMessage$.next(data as NicsECheckExtensionResponse);
    }
  }

  isExtensionInstalled(): boolean {
    return this.extensionInstalled.getValue();
  }
}